import { render, staticRenderFns } from "./FirstBanner.vue?vue&type=template&id=24dfc491&scoped=true"
import script from "./FirstBanner.vue?vue&type=script&lang=js"
export * from "./FirstBanner.vue?vue&type=script&lang=js"
import style0 from "./FirstBanner.vue?vue&type=style&index=0&id=24dfc491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfc491",
  null
  
)

export default component.exports